import dayjs from 'dayjs';

export function getStatus(status, endDate) {
  switch (status) {
    case 'ACCEPTED':
    case 'COMPLETED':
    case 'PENDING':
      if (endDate > Date.now()) {
        return 'Upcoming';
      }
      return 'Past';
    case 'CANCELLED_NO_CHARGE':
      return 'Cancelled without charge';
    case 'CANCELLED_WITH_CHARGE':
      return 'Cancelled with charge';
    default:
      return 'Unknown';
  }
}

export default [
  {
    field: 'id',
    headerName: 'ID',
    type: 'text',
    flex: 1,
    valueGetter: (params) => params?.row?.id,
  },
  {
    field: 'startDate',
    headerName: 'Start',
    type: 'date',
    flex: 1.5,
    valueFormatter: ({ value }) => dayjs(value).format('DD-MM-YYYY HH:mm'),
  },
  {
    hide: true,
    field: 'endDate',
    headerName: 'Finish',
    type: 'date',
    flex: 1,
    valueFormatter: ({ value }) => dayjs(value).format('DD-MM-YYYY HH:mm'),
  },
  {
    headerName: 'Duration',
    flex: 0.8,
    valueGetter: (params) => dayjs(params?.row?.endDate).diff(dayjs(params?.row?.startDate), 'hour', true).toString(),
  },
  {
    field: 'tutor',
    headerName: 'Tutor',
    type: 'text',
    flex: 1.5,
    valueGetter: (params) => {
      const tutor = params?.row?.tutors?.[0] ?? {};
      return `${tutor.firstName || ''} ${tutor.lastName || ''}`.trim();
    },
  },
  {
    field: 'subject',
    headerName: 'Subject',
    type: 'text',
    flex: 2,
    valueGetter: (params) => params?.row?.subject?.subjectName,
  },
  {
    field: 'learner',
    headerName: 'Learner',
    type: 'text',
    flex: 2,
    valueGetter: (params) => {
      const learner = params?.row?.learners?.[0] ?? {};
      return `${learner.firstName || ''} ${learner.lastName || ''}`.trim();
    },
  },
  {
    field: 'parent',
    headerName: 'Parent',
    type: 'text',
    flex: 2,
    valueGetter: (params) => {
      const parent = params?.row?.learners?.[0]?.parent ?? {};
      return `${parent.firstName || ''} ${parent.lastName || ''}`.trim();
    },
  },
  {
    field: 'lessonType',
    headerName: 'Type',
    type: 'multiple-choice',
    flex: 1,
    valueGetter: (params) => (params?.row?.freeTrial ? 'Free trial' : 'Normal'),
  },
  {
    field: 'tutorFee',
    headerName: 'Tutor fee',
    type: 'price',
    flex: 1,
    valueGetter: (params) => `£${(params?.row?.chargeToPath ?? 0) / 100}`,
    filterValueGetter: (params) => (params?.row?.chargeToPath ?? 0) / 100,
  },
  {
    field: 'parentFee',
    headerName: 'Parent fee',
    type: 'price',
    flex: 1,
    valueGetter: (params) => `£${(params?.row?.chargeToCustomer ?? 0) / 100}`,
    filterValueGetter: (params) => (params?.row?.chargeToCustomer ?? 0) / 100,
  },
  {
    field: 'status',
    headerName: 'Status',
    type: 'multiple-choice',
    flex: 1,
    valueGetter: (params) => getStatus(params?.row?.status, params?.row?.endDate),
  },
];
